import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";

interface IndexContractsProviderProps {
  children: ReactNode;
  callback?: () => void;
}

interface IndexContractsContextValue {
  modalConfig: ModalConfig;
  setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
  callback?: () => void;
}

const IndexContractsContext = createContext<
  IndexContractsContextValue | undefined
>(undefined);

const IndexContractsProvider: React.FC<IndexContractsProviderProps> = ({
  children,
  callback,
}) => {
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  return (
    <IndexContractsContext.Provider
      value={{ modalConfig, setModalConfig, callback }}
    >
      {children}
    </IndexContractsContext.Provider>
  );
};

const useIndexContractsContext = (): IndexContractsContextValue => {
  const context = useContext(IndexContractsContext);
  if (!context) {
    throw new Error(
      "useIndexContractsContext must be used within an IndexContractsProvider"
    );
  }
  return context;
};

export { IndexContractsProvider, useIndexContractsContext };
